import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PackageInformation } from '../../../../lib-os-components/src/lib/interfaces/package.interface';

@Injectable({
    providedIn: 'root',
})
export class PackageService {
    public constructor(private http: HttpClient) {}

    public getPackageInformation(serialnumber: string) {
        return this.http.get<PackageInformation>(`/api/product/${serialnumber}/package`);
    }
}
